/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'De siste i-app-varslerne',
    titleMeta: 'Viser nylige varsler fra CamAPS FX i appen',
    descriptionMeta: 'Her finner du teksten til de siste i-app-varslingene for appoppdateringer, sikkerhetsvarsler og oppdateringer av brukermanualen.',
    keywords: 'Varsler' ,
    localeMeta: 'nb_no',

    heading: 'De siste i-app-varslerne',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Oppdatering av Android-app (YpsoPump only) 28/10/2026',
    body_132:'Kjære CamAPS FX-bruker, en ny versjon av applikasjonen 1.4(195) vil være tilgjengelig i løpet av de neste dagene. Vennligst velg ditt foretrukne oppdateringstidspunkt ved å deaktivere den automatiske oppdateringen for CamAPS FX i Google Play Store. Hvis du har spørsmål, vennligst kontakt mylife-Diabetescare kundeservice.',

    header_131:'',
    body_131:'',

    header_130:'Oppdatering kreves (kun YpsoPump) 20/10/2026',
    body_130:'Oppdatering kreves! Denne versjonen av CamAPS FX kan krasje og starte på nytt oftere. Oppdater til den nyeste versjonen NÅ via Google Play Butikk. Appversjon 1.4(190) avvikles den 20/11/2026. Etter denne datoen vil “Auto Mode” ikke lenger være tilgjengelig før appen er oppdatert. Insulintilførselen via pumpen din vil fortsette.',

    header_129:'',
    body_129:'',

    header_128:'Oppdatering av brukermanual (kun YpsoPump) 15/10/2026',
    body_128:'En oppdatert versjon av brukermanualen er nå tilgjengelig. Du får tilgang til den fra hovedmenyen i CamAPS FX ved å velge Hjelp etter oppdatering til den nyeste appversjonen.',

    header_127:'iOS app oppdatering (YpsoPump only) 08/10/2026',
    body_127:'Kjære CamAPS FX bruker, en NY VERSJON av applikasjonen 1.4(196) vil være tilgjengelig de neste dagene. DEAKTIVER CamAPS FX AUTOMATISKE OPDATERINGER i App Store for å velge ditt foretrukne oppdateringstidspunkt. Hvis du har noen spørsmål, vennligst kontakt mylife-Diabetescare kundeservice.',

    header_126:'Oppdatering av Android-app (YpsoPump only) 02/10/2026',
    body_126:'Kjære CamAPS FX-bruker, en ny versjon av applikasjonen 1.4(194) vil være tilgjengelig i løpet av de neste dagene. Vennligst velg ditt foretrukne oppdateringstidspunkt ved å deaktivere den automatiske oppdateringen for CamAPS FX i Google Play Store. Hvis du har spørsmål, vennligst kontakt mylife-Diabetescare kundeservice.',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'',
    body_122:'',

    header_121:'Apple iOS 27-utgivelse 11/09/2026',
    body_121:'Apple vil snart lansere iOS 27. For å sikre uavbrutt bruk av CamAPS FX-appen, vennligst sjekk sensorprodusentens nettside for å bekrefte kompatibilitet mellom smarttelefon og operativsystem FØR du oppdaterer iPhone til iOS 27. Automatiske oppdateringer kan være PÅ som standard i telefoninnstillingene; vennligst vurder å slå dem AV.',

    header_120:'',
    body_120:'',

    header_119:'Oppdatering av brukermanual (kun YpsoPump) 10/09/2026',
    body_119:'En oppdatert versjon av brukermanualen er nå tilgjengelig. Du får tilgang til den fra hovedmenyen i CamAPS FX ved å velge Hjelp etter oppdatering til den nyeste appversjonen.',

    header_118:'Oppdatering av Android-app (YpsoPump only) 07/09/2026',
    body_118:'Kjære CamAPS FX-bruker, en ny versjon av applikasjonen 1.4(193) vil være tilgjengelig i løpet av de neste dagene. Vennligst velg ditt foretrukne oppdateringstidspunkt ved å deaktivere den automatiske oppdateringen for CamAPS FX i Google Play Store. Hvis du har spørsmål, vennligst kontakt mylife-Diabetescare kundeservice.',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'Deaktivering av Android-versjoner under 1.4(192) (Ypsopump only) 03/08/2026',
    body_111:'Kjære CamAPS FX-bruker, av hensyn til cybersikkerhet vil versjoner UNDER 1.4(192) bli AVVIKLET den 31/08/2026. Sørg for at appen din er OPPDATERT til versjon 1.4(192) før denne datoen. Hvis du har spørsmål, kan du kontakte mylife-Diabetescare kundeservice.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Android OS 17 utgivelse 24/06/2026',
    body_109:'Android vil snart lansere OS 17. For å sikre uavbrutt bruk av  CamAPS FX-appen, vennligst sjekk sensorprodusentens nettside for å bekrefte kompatibilitet mellom smarttelefon og operativsystem FØR du oppdaterer Android-enheten din til OS 17. Automatiske oppdateringer kan være PÅ som standard i telefoninnstillingene; vennligst slå dem AV.',

    header_108:'Dexcom G7 er tilgjengelig (kun Ypsopump) 23/06/2026',
    body_108:'Integrasjonen av Dexcom G7 CGM-systemet er nå tilgjengelig! Brukere som bytter fra Dexcom G6, finner en veiledning for byttet, feilsøkingshjelp og en oversikt over kompatible CGM-systemer på nettstedet vårt: www.mylife-diabetescare.com.',

    header_107:'',
    body_107:'',

    header_106:'Oppdatering av brukermanual (kun YpsoPump) 22/06/2026',
    body_106:'En oppdatert versjon av brukermanualen er nå tilgjengelig. Du får tilgang til den fra hovedmenyen i CamAPS FX ved å velge Hjelp.',

    header_105:'',
    body_105:'',

    header_104:'',
    body_104:'',

    header_103:'Oppdatering av Android-app (YpsoPump only) 12/06/2026',
    body_103:'Kjære mylife CamAPS FX-bruker, en ny versjon av applikasjonen 1.4(192) vil være tilgjengelig i løpet av de neste dagene. Vennligst velg ditt foretrukne oppdateringstidspunkt ved å deaktivere den automatiske oppdateringen for CamAPS FX i Google Play Store. Hvis du har spørsmål, vennligst kontakt mylife-Diabetescare kundeservice.',

    header_102:'',
    body_102:'',

    header_101:'',
    body_101:'',

    header_100:'',
    body_100:'',

    header_99:'',
    body_99:'',

    header_98:'Avslutning av gamle operativsystemer 22/05/2026',
    body_98:'Mens vi forbereder vår neste appoppdatering, vennligst merk at CamAPS FX KUN vil støttes på sensorkompatible telefoner som kjører OS 13 eller høyere eller Apple iOS 18 eller høyere. Etter denne utgivelsen vil brukere med telefoner som kjører UNDER OS 13 eller iOS 18 IKKE kunne OPPDATERE eller INSTALLERE CamAPS FX på nytt.',

    header_97:'Oppdatering av iOS-app 22/05/2026',
    body_97:'Kjære CamAPS FX-bruker, en ny versjon av CamAPS FX, 1.4(195), vil være tilgjengelig i løpet av de neste dagene. For å velge når du vil oppdatere, deaktiver AUTOMATISKE OPPDATERINGER i App Store. Brukere med versjoner UNDER Apple iOS 18 vil IKKE kunne OPPDATERE CamAPS FX til denne versjonen. En oppdatert versjon av brukermanualen er nå tilgjengelig. For spørsmål, vennligst kontakt mylife-Diabetescare kundeservice.',

    header_96:'',
    body_96:'',

    header_95:'',
    body_95:'',

    header_94:'',
    body_94:'',

    header_93:'Deaktivering av iOS-versjoner under 1.4(193) (kun Ypsopump) 22/04/2026',
    body_93:'Kjære CamAPS FX-bruker, av hensyn til cybersikkerhet vil VERSJONER UNDER 1.4(193) bli DEAKTIVERT 30. april. Sørg for at appen din er OPPDATERT til versjon 1.4(193) før denne datoen. Hvis du har spørsmål, vennligst kontakt mylife-Diabetescare kundeservice.',

    header_92:'Deaktivering av tidligere operativsystemer 21/04/2026',
    body_92:'Av hensyn til cybersikkerhet vil mylife CamAPS FX fra og med 30. juni 2026 KUN støttes på sensorkompatible telefoner som kjører følgende operativsystemer: Android OS 13 eller nyere og Apple iOS 18 eller nyere. Brukere av operativsystemer UNDER Android OS 13 eller Apple iOS 18 vil IKKE kunne OPPDATERE eller INSTALLERE PÅ NYTT mylife CamAPS FX etter denne datoen.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'',
    body_89:'',

    header_88:'',
    body_88:'',

    header_87:'Deaktivering av iOS-versjoner under 1.4(193) (kun Ypsopump) 16/03/2026',
    body_87:'Kjære CamAPS FX-bruker, av hensyn til cybersikkerhet vil VERSJONER UNDER 1.4(193) bli DEAKTIVERT 31. mars. Sørg for at appen din er OPPDATERT til versjon 1.4(193) før denne datoen. Hvis du har spørsmål, vennligst kontakt mylife-Diabetescare kundeservice.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'Oppdatering av Android-app (kun Ypsopump) 02/02/2026',
    body_82:'Kjære CamAPS FX-bruker, en NY VERSJON av applikasjonen vil være tilgjengelig i løpet av de neste dagene – 1.4(190). DEAKTIVER AUTOMATISKE OPPDATERINGER av CamAPS FX i Google Play Butikk for å kunne velge ønsket oppdateringstidspunkt. Av hensyn til cybersikkerhet vil VERSJONER UNDER 1.4(190) bli AVVIKLET 31. mars. Hvis du har spørsmål, vennligst kontakt mylife-Diabetescare kundeservice.',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'',
    body_77:'',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Melding fra mylife-Diabetescare (kun YpsoPump) 09/12/2025',
    body_74:'Du kan fylle på mylife YpsoPump-reservoaret én gang innen 7 dager etter første fylling. Les mer på reservoarsiden på mylife-diabetescare-nettstedet.',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'',
    body_72:'',
    body_72_link_text:'',
    body_72_end: '',
    body_72_link:'',

    header_71:'',
    body_71:'',
    body_71_link_text:'',
    body_71_end: '',
    body_71_link:'',

    header_70:'Viktig sikkerhetsinformasjon om sensoren i FreeStyle Libre 3-systemet ditt 25/11/2025',
    body_70:'Abbott har identifisert at noen FreeStyle Libre 3- og FreeStyle Libre 3 Plus-sensorer kan vise falskt lave glukoseverdier. Gå til',
    body_70_link_text:'www.FreeStyleCheck.com',
    body_70_end: ' for å sjekke om din nåværende eller ubrukte sensor(er) er potensielt berørt. Hvis sensoravlesningene ikke samsvarer med symptomene eller forventningene dine, slå av Auto-modus og bruk et blodsukkermålerapparat for å ta behandlingsbeslutninger. Hvis du har spørsmål eller må rapportere problemer med sensoren til FreeStyle Libre 3-systemet ditt, kontakt Abbott Kundeservice på 800 87 100. Serienummeret til din nåværende sensor finner du i appmenyen under Sensor.',
    body_70_link:'https://www.FreeStyleCheck.com',
	
    header_69:'iOS-appoppdatering (kun YpsoPump) 25/11/2025',
    body_69:'Kjære mylife CamAPS FX-bruker, en NY VERSJON av applikasjonen vil være tilgjengelig i løpet av de neste dagene. DEAKTIVER CamAPS FX AUTOMATISKE OPPDATERINGER i App Store for å velge ditt foretrukne oppdateringstidspunkt. Din nåværende versjon vil bli AVSLUTTET den 9. desember 2025. Hvis du har spørsmål, vennligst kontakt Ypsomed kundeservice.',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',

    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'VIKTIG SIKKERHETSINFORMASJON 28/10/2025',
    body_62:'Vennligst les og bekreft at du har lest den viktige sikkerhetsmeldingen',
    body_62_link_text:'N-0125',
    body_62_end: '. Gå til appmenyen -> Sikkerhetsmeldinger.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+mylife+Users+NO+final.pdf',

    header_61:'iOS-appoppdatering (YpsoPump bare) 02/10/2025',
    body_61:'For optimal appytelse, vennligst OPPDATER din mylife CamAPS FX til den NYESTE VERSJONEN (1.4(192)) via Apple App Store.',

    header_60:'',
    body_60:'',

    header_59:'iOS app oppdatering (kun YpsoPump) 22/09/2025',
    body_59:'Kjære mylife CamAPS FX bruker, en NY VERSJON av applikasjonen vil være tilgjengelig de neste dagene. DEAKTIVER CamAPS FX AUTOMATISKE OPDATERINGER i App Store for å velge ditt foretrukne oppdateringstidspunkt. En ny versjon av brukermanualen vil være tilgjengelig. Hvis du har noen spørsmål, vennligst kontakt Ypsomed kundeservice.',

    header_58:'iOS 26 utgivelse (YpsoPump kun) 13/09/2025',
    body_58:'Apple vil snart slippe iOS 26. For å sikre uavbrutt bruk av mylife CamAPS FX-applikasjonen, vennligst sjekk sensorprodusentens nettsted for å verifisere kompatibiliteten mellom smarttelefon og operativsystem før du oppdaterer din iPhone til iOS 26. Merk: Automatiske oppdateringer kan være aktivert i telefonens innstillinger som standard, vennligst deaktiver disse.',

    header_57:'Oppdatering av Android-app (kun YpsoPump) 26/08/2025',
    body_57:'Kjære mylife CamAPS FX-bruker, en ny versjon av applikasjonen vil være tilgjengelig i løpet av de neste 2 til 3 dagene. Vennligst velg ditt foretrukne oppdateringstidspunkt ved å deaktivere den automatiske oppdateringen for CamAPS FX i Google Play Store. En ny versjon av brukermanualen vil være tilgjengelig. Hvis du har spørsmål, vennligst kontakt Ypsomed kundeservice.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
    header_52:'',
    body_52:'',
	
    header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Avslutning av eldre appversjoner 01/07/2025',
    body_49:'Vennligst oppdater appen din til den nyeste versjonen som er tilgjengelig på Google Play. Den nåværende versjonen vil slutte å fungere 1. august 2025.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Av cybersikkerhetsgrunner vil mylife CamAPS FX fra 1. august 2025 kun støttes på sensor-kompatible telefoner som kjører Android-operativsystemer 12 og høyere. Brukere av operativsystemer under OS 10 vil ikke lenger kunne oppdatere eller installere mylife CamAPS FX på nytt etter denne datoen.',

    header_47:'',
    body_47:'',

    header_46:'iOS-oppdatering 09/06/2025',
    body_46:'En ny appversjon vil være tilgjengelig i løpet av de nærmeste dagene. Deaktiver de automatiske appoppdateringene for å velge ønsket oppdateringstidspunkt. Hvis du har spørsmål, kan du kontakte Ypsomeds kundeservice.',

    header_45:'Android OS 16 09/06/2025',
    body_45:'For å sikre uavbrutt bruk av mylife CamAPS FX-appen bør du sjekke produsentens nettsted for sensorer for å sikre kompatibilitet før du oppgraderer til Android OS 16. Merk: Automatiske oppdateringer kan være aktivert som standard i telefonens innstillinger.',

    header_44:'iOS-utgivelse (kun YpsoPump) 20/05/2025',
    body_44:'mylife CamAPS FX-appen er nå også tilgjengelig for iPhone! Hvis du vurderer å bytte til iOS, kan du gå til delen «Viktig informasjon for iOS-brukere» på www.mylife-diabetescare.com/no-NO/mylife-loop.html.En ny versjon av brukermanualen er tilgjengelig.',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',
	
    header_41:'',
    body_41:'',

    header_40:'Ny oppdatering (18/03/2025)',
    body_40:'tKjære bruker av mylife CamAPS FX,  En ny versjon av appen vil være klar innen de neste 48 timene. For å velge foretrukket oppdateringstid, slå av automatisk oppdatering for CamAPS FX i Google Play Store. Hvis du har noen spørsmål, vennligst kontakt Ypsomed kundeservice.',
	
    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'',
    body_37:'',

    header_36:'Oppdatering av appen 06/01/2025',
    body_36:'tKjære bruker av mylife CamAPS FX, En ny versjon av appen vil være klar innen de neste 48 timene. For å velge foretrukket oppdateringstid, slå av automatisk oppdatering for CamAPS FX i Google Play Store. Hvis du har noen spørsmål, vennligst kontakt Ypsomed kundeservice.',

	header_35:'OS 8 & 9 29/12/2024',
    body_35:'Av cybersikkerhetsgrunner vil mylife CamAPS FX fra 1. januar 2025 kun støttes på sensor-kompatible telefoner som kjører Android-operativsystemer 10 og høyere. Brukere av operativsystemer under OS 10 vil ikke lenger kunne oppdatere eller installere mylife CamAPS FX på nytt etter denne datoen. Påminnelse, systemet er ennå ikke kompatibelt med OS15.',
	
	header_34:'',
    body_34:'',
	
	header_33:'Varsel om planlagt vedlikehold 05/12/2024',
    body_33:'På grunn av planlagt vedlikehold av CamAPS FX-tjenestens sky, vil Companion-funksjonen være utilgjengelig 7. desember fra kl. 10:00 GMT i omtrent tre timer. Vi beklager eventuelle ulemper dette måtte medføre.',
	
	header_32:'Oppdatering av brukerhåndboken 28/11/2024',
    body_32:'En oppdatert versjon av brukerhåndboken er tilgjengelig.',
	
	header_31:'Oppdatering av appen 17/11/2024',
    body_31:'tKjære bruker av mylife CamAPS FX, En ny versjon av appen vil være klar innen de neste 48 timene. For å velge foretrukket oppdateringstid, slå av automatisk oppdatering for CamAPS FX i Google Play Store. Hvis du har noen spørsmål, vennligst kontakt Ypsomed kundeservice.',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Av cybersikkerhetsgrunner vil mylife CamAPS FX fra 1. januar 2025 kun støttes på sensor-kompatible telefoner som kjører Android-operativsystemer 10 og høyere. Brukere av operativsystemer under OS 10 vil ikke lenger kunne oppdatere eller installere mylife CamAPS FX på nytt etter denne datoen.',
	
	header_29:'Oppdatering av appen 09/10/2024',
    body_29:'tKjære bruker av mylife CamAPS FX, En ny versjon av appen vil være klar innen de neste 48 timene. For å velge foretrukket oppdateringstid, slå av automatisk oppdatering for CamAPS FX i Google Play Store. Hvis du har noen spørsmål, vennligst kontakt Ypsomed kundeservice.',
	
	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Av cybersikkerhetsgrunner vil mylife CamAPS FX fra 1. januar 2025 kun støttes på sensor-kompatible telefoner som kjører Android-operativsystemer 10 og høyere. Brukere av operativsystemer under OS 10 vil ikke lenger kunne oppdatere eller installere mylife CamAPS FX på nytt etter denne datoen.',

    header_27:'',
    body_27:'',

    header_26:'',
    body_26:'',

    header_25:'',
    body_25:'',

    header_24:'',
    body_24:'',

    header_23:'',
    body_23:'',

	header_22:'',
    body_22:'',
	
	header_21:'',
    body_21:'',
	
	header_20:'',
    body_20:'',
	
	header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

    header_16:'',
    body_16:'',

    header_15:'',
    body_15:'',

    header_14:'',
    body_14:'',

    header_13:'',
    body_13:'',
    body_13_link_text:'',
    body_13_end: '',
    body_13_link:'',

    header_12:'',
    body_12:'',

    header_11:'',
    body_11:'',

    header_10:'',
    body_10:'',

    header_9:'',
    body_9:'',

    header_8:'',
    body_8:'',

    header_7:'',
    body_7:'',

    header_6:'',
    body_6:'',

    header_5:'',
    body_5:'',

    header_4:'',
    body_4:'',

    header_3:'',
    body_3:'',

    header_2:'',
    body_2:'',

    header_1:'',
    body_1:'',
};
